module.exports = __webpack_public_path__ + "static/media/img-fa5eb36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/png/ic-search.png
// module id = 2285
// module chunks = 39